/* global axios */
/* eslint-disable max-classes-per-file -- resource clients share one module */
import ApiClient from './ApiClient';

const queryString = params =>
  new URLSearchParams(
    Object.entries(params || {}).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  ).toString();

class WebOrderResourceAPI extends ApiClient {
  list(params = {}) {
    const query = queryString(params);
    return axios.get(query ? `${this.url}?${query}` : this.url);
  }

  bulkUpdate(ids, attributes) {
    return axios.patch(`${this.url}/bulk_update`, {
      ids,
      ...attributes,
    });
  }

  assign(id, userId) {
    return axios.post(`${this.url}/${id}/assign`, { user_id: userId });
  }

  unassign(id) {
    return axios.delete(`${this.url}/${id}/unassign`);
  }

  addNote(id, note) {
    return axios.post(`${this.url}/${id}/add_note`, { note });
  }

  recall(id, recalled) {
    return axios.post(`${this.url}/${id}/recall`, { recalled });
  }

  recordCall(id) {
    return axios.post(`${this.url}/${id}/record_call`);
  }

  defaultImpact() {
    return axios.get(`${this.url}/default_impact`);
  }

  agentPerformance(params = {}) {
    const query = queryString(params);
    return axios.get(
      query
        ? `${this.url}/agent_performance?${query}`
        : `${this.url}/agent_performance`
    );
  }

  assignmentCounts() {
    return axios.get(`${this.url}/assignment_counts`);
  }

  filter(params = {}) {
    return axios.post(`${this.url}/filter`, params);
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }

  markInvoicePrinted(ids) {
    return axios.patch(`${this.url}/mark_invoice_printed`, { ids });
  }

  pickingChecklist(params = {}) {
    const query = queryString(params);
    return axios.get(
      query
        ? `${this.url}/picking_checklist?${query}`
        : `${this.url}/picking_checklist`
    );
  }

  duplicatePhoneStats(params = {}) {
    const query = queryString(params);
    return axios.get(
      query
        ? `${this.url}/duplicate_phone_stats?${query}`
        : `${this.url}/duplicate_phone_stats`
    );
  }
}

class WebCustomersAPI extends WebOrderResourceAPI {
  tags(query = '') {
    const qs = queryString({ q: query });
    return axios.get(qs ? `${this.url}/tags?${qs}` : `${this.url}/tags`);
  }
}

export const webOrdersAPI = new WebOrderResourceAPI('web_orders', {
  accountScoped: true,
});
export const webProductsAPI = new WebOrderResourceAPI('web_products', {
  accountScoped: true,
});
export const webCustomersAPI = new WebCustomersAPI('web_customers', {
  accountScoped: true,
});
export const webOrderPickupAddressesAPI = new WebOrderResourceAPI(
  'web_order_pickup_addresses',
  { accountScoped: true }
);
export const webOrderCustomersAPI = new WebOrderResourceAPI(
  'web_order_customers',
  { accountScoped: true }
);
export const woocommerceStoresAPI = new WebOrderResourceAPI(
  'woocommerce_stores',
  { accountScoped: true }
);
export const deliveryPartnerAccountsAPI = new WebOrderResourceAPI(
  'delivery_partner_accounts',
  { accountScoped: true }
);
export const deliveryShipmentsAPI = new WebOrderResourceAPI(
  'delivery_shipments',
  { accountScoped: true }
);

class WebOrderSettingAPI extends ApiClient {
  constructor() {
    super('web_order_setting', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, data);
  }
}

export const webOrderSettingsAPI = new WebOrderSettingAPI();

export { queryString };
